import React, { FunctionComponent } from "react"
import { FormControl } from "react-bootstrap"
import RoleAssignmentHashTableTypes from "src/pages/hr/Types/RoleAssignmentHashTableTypes"
import roleAssignmentHelper from "../../Utils/RoleAssignmentHelper"
import "./RoleAssignmentPermissionControls.css"

interface Props {
    manageParentState: Function
    bucketItem: RoleAssignmentHashTableTypes
    readonly: boolean
}

const RoleAssignmentPermissionControls: FunctionComponent<Props> = (props) => {

    const { manageParentState, bucketItem, readonly } = props
    const { addOrDropView, addOrDropEdit } = roleAssignmentHelper
    const disabled = bucketItem[1].dropRole || (!bucketItem[1].hasRole && !bucketItem[1].addRole )

    return (
        <div className={`RoleAssignmentPermissionControls ${disabled ? "RoleAssignmentPermissionControlsDisabled" : "RoleAssignmentPermissionControlsEnabled"}`}>
            <div className={`RoleAssignmentPermissionControlsBtn ${(bucketItem[1].addView && !bucketItem[1].dropRole) ? "RoleAssignmentPermissionControlsBtnAddView" : "RoleAssignmentPermissionControlsBtnDontAddView"} ${(bucketItem[1].dropView && !bucketItem[1].dropRole) ? "RoleAssignmentPermissionControlsBtnDropView" : "RoleAssignmentPermissionControlsBtnDontDropView"} ${bucketItem[1].dropRole ? "RoleAssignmentPermissionControlsBtnDisabled" : "RoleAssignmentPermissionControlsBtnNotDisabled"}`}
                onClick={() => {
                    if (!disabled && !readonly) {
                        addOrDropView(bucketItem)
                        manageParentState(() => [{ key: "busy", value: false }])
                    }
                }}
            >
                <div className="RoleAssignmentPermissionControlsBtnCheckbox">
                    <FormControl
                        onChange={() => null}
                        checked={(bucketItem[1].hasView && !bucketItem[1].dropView && !disabled) || bucketItem[1].addView}
                        type="checkbox"
                        disabled={disabled || readonly}
                    />
                </div>
                <p>View</p>
            </div>
            <div className={`RoleAssignmentPermissionControlsBtn ${(bucketItem[1].addEdit && !bucketItem[1].dropRole) ? "RoleAssignmentPermissionControlsBtnAddEdit" : "RoleAssignmentPermissionControlsBtnDontAddEdit"} ${(bucketItem[1].dropEdit && !bucketItem[1].dropRole) ? "RoleAssignmentPermissionControlsBtnDropEdit" : "RoleAssignmentPermissionControlsBtnDontDropEdit"} ${bucketItem[1].dropRole ? "RoleAssignmentPermissionControlsBtnDisabled" : "RoleAssignmentPermissionControlsBtnNotDisabled"}`}
                onClick={() => {
                    if (!disabled && !readonly) {
                        addOrDropEdit(bucketItem)
                        manageParentState(() => [{ key: "busy", value: false }])
                    }
                }}
            >
                <div className="RoleAssignmentPermissionControlsBtnCheckbox">
                    <FormControl
                        onChange={() => null}
                        checked={(bucketItem[1].hasEdit && !bucketItem[1].dropEdit && !disabled) || bucketItem[1].addEdit}
                        type="checkbox"
                        disabled={disabled || readonly}
                    />
                </div>
                <p>Edit</p>
            </div>
        </div>
    )
}

export default RoleAssignmentPermissionControls